export default __webpack_public_path__ + "static/media/Greef-Karga.a7351567.webp";